import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ExternalLinkIcon } from '@assets/svgs';
import { QuoteItem } from '../types';
import { formatEffectiveDate, getQuoteStatusLabel } from '../utils/formatters';
import { currentItemStyles, externalLinkIconStyle } from '../utils/constants';
import { QuoteGetResponse } from '@lio/api-types';

interface QuoteCardProps {
  quote: QuoteItem | QuoteGetResponse;
  isCurrent?: boolean;
}

export const QuoteCard = ({ quote, isCurrent = false }: QuoteCardProps) => {
  const quoteNumber = quote.policyNumber?.policyNumber || quote.id;
  const offering = quote.offering?.label || quote.offering?.insuranceProduct?.name || '';
  // Handle both statusId (QuoteItem) and status?.id (useQuote)
  const statusId = 'statusId' in quote ? quote.statusId : quote.status?.id;
  const status = getQuoteStatusLabel(statusId || '');
  const effectiveDate = formatEffectiveDate(quote.effectiveOn);

  const content = (
    <Box
      sx={{
        px: 2,
        mb: 1,
        ...currentItemStyles(isCurrent),
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography
            variant='body2'
            display='block'
            sx={{
              color: isCurrent ? 'text.primary' : 'secondary.main',
              fontWeight: 700,
              '&:hover': isCurrent ? undefined : { textDecoration: 'underline' },
            }}
          >
            {quoteNumber} {!isCurrent && <ExternalLinkIcon width='10px' height='10px' style={externalLinkIconStyle} />}
          </Typography>
          <Typography variant='caption' color='text.secondary' display='block'>
            {offering} {status ? `- ${status}` : ''}
          </Typography>
        </Box>
        <Typography variant='body2' color='text.secondary' fontWeight='normal' sx={{ whiteSpace: 'nowrap', ml: 1 }}>
          {effectiveDate}
        </Typography>
      </Box>
    </Box>
  );

  if (isCurrent) {
    return content;
  }

  return (
    <Link
      to={`/quote/${quote.id}`}
      target='_blank'
      rel='noopener noreferrer'
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      {content}
    </Link>
  );
};
